import React from "react";
import { BottomMenuButton } from "../../bottom-menu/bottom-menu-button";
import { BottomMenuButtons, IBottomMenuButton } from "../../bottom-menu/buttons";

export const BottomBackgroundMenu = ({
	menuItems,
	showBackButton,
	onBack,
}: {
	/** As argument so they can be prefetched */
	menuItems: readonly IBottomMenuButton[];
	showBackButton: boolean;
	onBack: () => void;
}) => {
	return (
		<BottomMenuButtons showBackButton={showBackButton} onBack={onBack}>
			{menuItems.map((props) => {
				return <BottomMenuButton {...props} key={props.id} />;
			})}
		</BottomMenuButtons>
	);
};
BottomBackgroundMenu.displayName = "BottomBackgroundMenu";
